module.exports = __webpack_public_path__ + "static/black_dragon-0b836f0e48b0dc3c5c8fbfce6d1a7d9b.png";